// extracted by mini-css-extract-plugin
module.exports = {"main":"Rating_main__b5NnC","icon":"Rating_icon__35OP0","skeleton":"Rating_skeleton__3xmKv"};